import formName from 'constants/formName'
import { PreferencesFormType, StateType } from 'data/types'
import { getFormValues } from 'redux-form'
import { createSelector } from 'reselect'

import auth from '../../Auth/selectors'

const getInitialValues: (state: StateType) => PreferencesFormType = createSelector(
  auth.getLocalCurrency,
  auth.localSettings.getOrderFilledSoundSetting,
  (localCurrency, orderFilledSound) => ({ localCurrency, orderFilledSound })
)

const getValues = (state: StateType): PreferencesFormType =>
  getFormValues(formName.PREFERENCES)(state) as PreferencesFormType

export default {
  getInitialValues,
  getValues
}
